import { HttpMethod } from "types";

const BASE_URL = "/api/v1/";

export const endpoints = {
  list: {
    url: BASE_URL + "comissao",
    method: HttpMethod.GET,
  },
  getOne: {
    url: (comissionId: string) => BASE_URL + `pasta/comissao/${comissionId}`,
    method: HttpMethod.GET,
  },
  create: {
    url: BASE_URL + "comissao",
    method: HttpMethod.POST,
  },
  update: {
    url: (comissionId: string) => BASE_URL + `comissao/${comissionId}`,
    method: HttpMethod.PUT,
  },
} as const;
